import { Subject, debounceTime } from 'rxjs';
import { CoordinatorService, MANIFEST_STORE_DELAY } from './coordinator.service';

type VALUEDCT = { [tag: string]: string[] };

export type BTSPAR = {
    id: string;
    originId: string;
    ownerId?: string;
    valueDct: VALUEDCT;
};
export class BinaryTreeStorage {
    id: string;
    ownerId: string;
    originId: string;

    private _valueDct: VALUEDCT = {};

    private _markForManifestStoreSubject$ = new Subject<void>();
    private _markForManifestStore$ = this._markForManifestStoreSubject$.pipe(
        debounceTime(MANIFEST_STORE_DELAY),
    );

    constructor(
        public coords: CoordinatorService,
        params: BTSPAR,
    ) {
        this.id = params.id;
        this.ownerId = params.ownerId || '_current';
        this.originId = params.originId;
        this._valueDct = params.valueDct;

        this._markForManifestStore$.subscribe(() => this._manifestStore());
    }

    markForManifestStore() {
        this._markForManifestStoreSubject$.next();
    }

    private _manifestStore() {
        this.coords.manifest$.store({
            type: 'bt-storage',
            id: this.id,
            valueMap: new Map<string, any>([['bts', this.save()]]),
        });
    }

    manifestDelete() {
        return {
            id: this.id,
            type: 'bt-storage',
        };
    }

    export() {
        const ls: [string, string[]] = [this.id, ['bt-storage']];
        return ls;
    }

    map(): Map<string, Set<string>> {
        return new Map(Object.entries(this._valueDct).map((tpl) => [tpl[0], new Set(tpl[1])]));
    }

    set(params: VALUEDCT, isReport = false) {
        this._valueDct = params;
        if (!isReport) {
            this.markForManifestStore();
            this.coords.searchArchive$.clearCacheHitset();
        }
    }

    save(): BTSPAR | undefined {
        if (!Object.keys(this._valueDct).length) return;

        return {
            id: this.id,
            ownerId: this.ownerId,
            originId: this.originId,
            valueDct: this._valueDct,
        };
    }
}
